const isProUser = (user) => user?.publisher?.payment_authorized || false;

export default isProUser;
